import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import ScreenViewForm from './ScreenViewForm'

const EditScreenViewModal = props => {
  return (
    <ControlledModal width="28rem" {...props}>
      <ModalHeader />
      <ScreenViewForm />
    </ControlledModal>
  )
}

export default EditScreenViewModal
